import request from '@/utils/request'

let Bargain = {

    /*砍价活动列表*/
    bargainList(data) {
        return request._post('/shop/plus.bargain.active/index', data);
    },
    /*删除*/
    deleteBargain(data) {
        return request._post('/shop/plus.bargain.active/delete', data);
    },
    /*添加砍价活动*/
    addActive(data) {
      return request._post('/shop/plus.bargain.active/add', data);
    },
    /*获取砍价活动数据*/
    editActive(data) {
      return request._get('/shop/plus.bargain.active/edit', data);
    },
    /*保存砍价活动*/
    saveActive(data) {
      return request._post('/shop/plus.bargain.active/edit', data);
    },
    /*获得商品详情*/
    detail(data) {
        return request._post('/shop/plus.bargain.bargain/detail', data);
    },
    /*保存*/
    saveData(data) {
        return request._post('/shop/plus.bargain.bargain/saveData', data);
    },
    /*保存*/
    editSetting(data) {
        return request._post('/shop/plus.bargain.setting/index', data);
    },
    /*获取*/
    settingDetail(data) {
        return request._get('/shop/plus.bargain.setting/index', data);
    },
    /*记录*/
    taskList(data) {
        return request._get('/shop/plus.bargain.task/index', data);
    },
    /*记录详情*/
    help(data) {
        return request._get('/shop/plus.bargain.task/help', data);
    },
}

export default Bargain;



// WEBPACK FOOTER //
// ./src/api/bargain.js